<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>widgets</mat-icon>
        </button>
        <span>Widgettypen wählen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">
        <div class="option" *ngFor="let entry of widgetTypes" (click)="selectType(entry.type)">

            <mat-checkbox class="checkbox" [checked]="entry.type.wtypeid === data"></mat-checkbox>
            <div>
                <div class="headline">
                    {{entry.pretty}}
                </div>
            </div>
            
        </div>
    </div>

</div>